import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProfileGuard } from '@guards/profile/profile.guard';
import { ClientResolver, LocalesResolver } from 'core/resolvers';
import { RankingListComponent } from './ranking-list/ranking-list.component';

const ranking: Routes = [
  {
    path: 'ranking',
    title: 'parentRanking',
    resolve: {
      locales: LocalesResolver,
      client: ClientResolver
    },
    children: [
      {
        path: '',
        title: 'rankings',
        component: RankingListComponent,
        canActivate: [ProfileGuard],
        resolve: {
          client: ClientResolver
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(ranking)],
  exports: [RouterModule]
})
export class RankingRoutingModule {}
